import { Outlet, useLocation } from 'react-router-dom';
import { BottomTabs } from './BottomTabs';
import { RivlLogo } from '../common/RivlLogo';
import { ThemeToggle } from '../common/ThemeToggle';
import { NotificationBell } from '../common/NotificationBell';
import { ActiveRunBanner } from '../common/ActiveRunBanner';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { Button } from '../ui/button';

const FULL_SCREEN_PATHS = ['/run/live', '/scanner'];

function isFullScreen(pathname) {
  if (pathname.startsWith('/scanner') && pathname !== '/scanner/activate') return true;
  if (pathname === '/run/live') return true;
  if (pathname.match(/^\/events\/[^/]+\/race$/)) return true;
  return false;
}

export function MobileLayout() {
  const { pathname } = useLocation();
  const fullScreen = isFullScreen(pathname);

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-background z-40 overflow-auto" data-testid="mobile-fullscreen">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="mx-auto w-full max-w-md min-h-screen flex flex-col relative border-x border-border">
        <ActiveRunBanner />
        <header className="sticky top-0 z-30 bg-background/95 backdrop-blur border-b border-border">
          <div className="flex items-center justify-between px-4 py-3">
            <Link to="/"><RivlLogo size="md" /></Link>
            <div className="flex items-center gap-1">
              <ThemeToggle />
              <Button asChild variant="ghost" size="icon" aria-label="Friends" data-testid="header-friends">
                <Link to="/friends"><Users className="h-4 w-4" /></Link>
              </Button>
              <NotificationBell />
            </div>
          </div>
        </header>
        <main className="flex-1 pb-24" data-testid="mobile-main">
          <Outlet />
        </main>
        <BottomTabs />
      </div>
    </div>
  );
}
